// Nearest vertically scrolling ancestor; null means the page itself scrolls. Stops below <body>: its overflow
// propagates to the viewport, so as an IntersectionObserver root it would count everything as visible.
export function getScrollParent(element: HTMLElement): HTMLElement | null {
  for (let parent = element.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
    if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY)) {
      return parent;
    }
  }

  return null;
}
